import React, { Component } from "react";
import { Grid, Card, Table, Button, Form, Tag } from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Crud_Catalogos from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";

class IpWhitelistUsuarioPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ips: [],
      usuarioId: "",
      cidr: "",
      descripcion: "",
      activo: true,
      buscarUsuarioId: "",
      loading: false,
    };
  }

  buscarIps = () => {
    const { buscarUsuarioId } = this.state;
    if (!buscarUsuarioId) {
      NotificationManager.warning("Ingrese un ID de usuario");
      return;
    }
    this.setState({ loading: true });
    Crud_Catalogos("ip-whitelist/usuario/" + buscarUsuarioId, "", "get", "", [])
      .then((res) => this.setState({ ips: res || [], loading: false }))
      .catch(() => {
        NotificationManager.error("Error al cargar IPs del usuario");
        this.setState({ loading: false });
      });
  };

  agregarIp = (e) => {
    e.preventDefault();
    const { usuarioId, cidr, descripcion, activo } = this.state;
    if (!usuarioId || !cidr.trim()) {
      NotificationManager.warning("Usuario ID y CIDR son obligatorios");
      return;
    }
    Crud_Catalogos("ip-whitelist/usuario", "", "post", "", {
        usuarioId: parseInt(usuarioId),
        cidr: cidr.trim(),
        descripcion: descripcion.trim(),
        activo,
      })
      .then(() => {
        NotificationManager.success("IP de usuario agregada");
        this.setState({ cidr: "", descripcion: "", activo: true });
        if (this.state.buscarUsuarioId === this.state.usuarioId) {
          this.buscarIps();
        }
      })
      .catch(() => NotificationManager.error("Error al agregar IP"));
  };

  eliminarIp = (id) => {
    if (!window.confirm("¿Eliminar esta IP?")) return;
    Crud_Catalogos("ip-whitelist/usuario/" + id, "", "delete", "")
      .then(() => {
        NotificationManager.success("IP eliminada");
        this.buscarIps();
      })
      .catch(() => NotificationManager.error("Error al eliminar IP"));
  };

  render() {
    const { ips, usuarioId, cidr, descripcion, activo, buscarUsuarioId, loading } = this.state;
    return (
      <SiteWrapper>
        <div className="container mt-3">
          <Grid.Row>
            <Grid.Col sm={12} lg={5}>
              <Card>
                <Card.Header>
                  <Card.Title>Agregar IP por Usuario</Card.Title>
                </Card.Header>
                <Card.Body>
                  <form onSubmit={this.agregarIp}>
                    <Form.Group label="Usuario ID">
                      <Form.Input
                        type="number"
                        placeholder="ID del usuario"
                        value={usuarioId}
                        onChange={(e) => this.setState({ usuarioId: e.target.value })}
                      />
                    </Form.Group>
                    <Form.Group label="CIDR / IP">
                      <Form.Input
                        placeholder="Ej: 192.168.1.0/24 o 10.0.0.1"
                        value={cidr}
                        onChange={(e) => this.setState({ cidr: e.target.value })}
                      />
                    </Form.Group>
                    <Form.Group label="Descripción">
                      <Form.Input
                        placeholder="Descripción de la IP"
                        value={descripcion}
                        onChange={(e) => this.setState({ descripcion: e.target.value })}
                      />
                    </Form.Group>
                    <Form.Group label="">
                      <Form.Checkbox
                        label="Activo"
                        checked={activo}
                        onChange={(e) => this.setState({ activo: e.target.checked })}
                      />
                    </Form.Group>
                    <Button color="primary" type="submit" block>
                      Agregar
                    </Button>
                  </form>
                </Card.Body>
              </Card>
            </Grid.Col>

            <Grid.Col sm={12} lg={7}>
              <Card>
                <Card.Header>
                  <Card.Title>IP Whitelist por Usuario</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Grid.Row className="mb-3">
                    <Grid.Col sm={8}>
                      <Form.Input
                        type="number"
                        placeholder="Buscar por Usuario ID"
                        value={buscarUsuarioId}
                        onChange={(e) => this.setState({ buscarUsuarioId: e.target.value })}
                      />
                    </Grid.Col>
                    <Grid.Col sm={4}>
                      <Button color="primary" block onClick={this.buscarIps} icon="search">
                        Buscar
                      </Button>
                    </Grid.Col>
                  </Grid.Row>
                </Card.Body>
                {loading ? (
                  <Card.Body>Cargando...</Card.Body>
                ) : (
                  <Table cards striped responsive className="table-vcenter">
                    <Table.Header>
                      <Table.Row>
                        <Table.ColHeader>ID</Table.ColHeader>
                        <Table.ColHeader>Usuario ID</Table.ColHeader>
                        <Table.ColHeader>CIDR</Table.ColHeader>
                        <Table.ColHeader>Descripción</Table.ColHeader>
                        <Table.ColHeader>Activo</Table.ColHeader>
                        <Table.ColHeader>Fecha Creación</Table.ColHeader>
                        <Table.ColHeader>Acciones</Table.ColHeader>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {ips.map((ip) => (
                        <Table.Row key={ip.id}>
                          <Table.Col>{ip.id}</Table.Col>
                          <Table.Col>{ip.usuarioId}</Table.Col>
                          <Table.Col><strong>{ip.cidr}</strong></Table.Col>
                          <Table.Col>{ip.descripcion}</Table.Col>
                          <Table.Col>
                            <Tag color={ip.activo ? "green" : "red"}>
                              {ip.activo ? "Sí" : "No"}
                            </Tag>
                          </Table.Col>
                          <Table.Col>
                            {ip.fechaCreacion
                              ? new Date(ip.fechaCreacion).toLocaleString()
                              : ""}
                          </Table.Col>
                          <Table.Col>
                            <Button
                              color="danger"
                              size="sm"
                              icon="trash-2"
                              onClick={() => this.eliminarIp(ip.id)}
                            />
                          </Table.Col>
                        </Table.Row>
                      ))}
                      {ips.length === 0 && (
                        <Table.Row>
                          <Table.Col colSpan={7} alignContent="center">
                            No hay IPs registradas
                          </Table.Col>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                )}
              </Card>
            </Grid.Col>
          </Grid.Row>
        </div>
      </SiteWrapper>
    );
  }
}

export default IpWhitelistUsuarioPage;
